import { SelectItemResponse } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'
import type { Refund } from '@src/type/refund'
import { stringify } from 'qs'

export type ResType = SelectItemResponse<{ product_challenge_payback: Refund[]; count?: number }>

export type SelectQuery = {
	offset?: number
	limit?: number
	getTotal?: boolean
}

export const getRefunds = async ({ offset, limit, getTotal }: SelectQuery): Promise<ResType> => {
	const queryString = stringify({
		offset,
		limit,
		get_total: getTotal,
	})

	const response = await client.get<ResType>(`/products/payback?${queryString}`)

	return response.data
}
